import { ChevronDownIcon } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuTrigger,
} from '@nesso/ui/primitives/dropdown-menu';

export type UsageHistoryFilterValue = 3 | 6 | 12;

const FILTER_OPTIONS: UsageHistoryFilterValue[] = [3, 6, 12];

export const DEFAULT_FILTER_VALUE: UsageHistoryFilterValue = 6;

type PlanBillingUsageHistoryFilterProps = {
    value: UsageHistoryFilterValue;
    onValueChange: (value: UsageHistoryFilterValue) => void;
};

/**
 * Time filter for usage history. Per NSS-470, it is only rendered from the 7th
 * billing cycle onward (the parent card gates it via `showTimeFilter`).
 */
export function PlanBillingUsageHistoryFilter({
    value,
    onValueChange,
}: PlanBillingUsageHistoryFilterProps) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm" className="font-medium" type="button">
                    Last {value} billing cycles
                    <ChevronDownIcon />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuRadioGroup
                    value={String(value)}
                    onValueChange={(next) => onValueChange(Number(next) as UsageHistoryFilterValue)}
                >
                    {FILTER_OPTIONS.map((cycles) => (
                        <DropdownMenuRadioItem key={cycles} value={String(cycles)} variant="plain">
                            Last {cycles} billing cycles
                        </DropdownMenuRadioItem>
                    ))}
                </DropdownMenuRadioGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
